import { cn } from '@/lib/cn';

/**
 * Logo oficial de ISOFT.
 * Assets en /public/brand (wordmark e isotipo oficiales del manual de marca).
 * - variant 'wordmark': el logotipo "isoft" completo (uso primario sobre blanco).
 * - variant 'isotipo': el símbolo cuadrado (espacios reducidos, sidebar, avatar).
 * - variant 'lockup': isotipo + texto "People" (producto).
 * - reversed: invierte el wordmark a blanco para fondos oscuros (Navy).
 */
const WORDMARK = '/brand/isoft-wordmark.png';
const ISOTIPO = '/brand/isoft-isotipo.png';

export function IsoftWordmark({
  className,
  reversed = false,
}: {
  className?: string;
  reversed?: boolean;
}) {
  return (
    <img
      src={WORDMARK}
      alt="ISOFT"
      draggable={false}
      className={cn('h-8 w-auto select-none', className)}
      style={reversed ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
  );
}

export function IsoftIsotipo({ className }: { className?: string }) {
  return (
    <img
      src={ISOTIPO}
      alt="ISOFT"
      draggable={false}
      className={cn('h-9 w-9 select-none rounded-lg', className)}
    />
  );
}

/** Lockup de producto: isotipo + "ISOFT People". `onDark` para sidebar Navy. */
export function IsoftLockup({
  className,
  onDark = false,
}: {
  className?: string;
  onDark?: boolean;
}) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <IsoftIsotipo className="h-8 w-8" />
      <span
        className={cn(
          'text-base font-semibold tracking-wide',
          onDark ? 'text-white' : 'text-font-primary',
        )}
      >
        ISOFT <span className={onDark ? 'text-primary-light' : 'text-primary'}>People</span>
      </span>
    </div>
  );
}
